import { getHamplitudeProperties } from 'usage-tracker-core/metaProperties';
import { hamplitudeKey } from 'usage-tracker-core/storageKeys';
import tempStorage from 'usage-tracker-core/containers/tempStorage';
import anonymousStorage from 'usage-tracker-core/containers/anonymousStorage';
export const getUuid = location => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.has('uuid') ? searchParams.get('uuid') : undefined;
};
export const resetAmplitudeStorageIfNeeded = deviceId => {
  const currentTime = Date.now(); // Attempts to retrieve the current Amplitude Storage or fallbacks
  // to the default Amplitude Storage (which means this is safe to ignore)

  const {
    device_id,
    session_id
  } = getHamplitudeProperties(tempStorage.getItem, currentTime, deviceId); // If the LocalStorage has a deviceId matching and the currentTime is different
  // from the registered sessionId (meaning this is not a fallback data)
  // Then we want to erase the data from the LocalStorage

  if (device_id === deviceId && currentTime !== session_id) {
    tempStorage.removeItem(hamplitudeKey);
  } // When switching from anonymous to non-anonymous we want to clear the
  // anonymous tracker sessionStorage


  anonymousStorage.removeItem(hamplitudeKey);
};